import React from "react";
import { Code } from "@singlestore/fusion/components/typography";

import "./InlineCode.scss";

type InlineCodeProps = {};

export function InlineCode({
    children,
}: React.PropsWithChildren<InlineCodeProps>) {
    return (
        <Code variant="code-1" className="inline-code">
            {children}
        </Code>
    );
}
